import { Replay, Search } from "@mui/icons-material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Box, Button, Grid, Tooltip } from "@mui/material";
import React, { PropsWithChildren, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";


const isFragment = (element: any) => {
  return element.type === React.Fragment;
};

interface Props extends PropsWithChildren {
  formId?: string;
  onReset?: () => void;
  onSearch?: () => void;
  // TODO: To remove where is used
  // Do not use !!! not needed
  showExtrasFilters?: boolean;
  showResetAndSerchButton?: boolean;
  disableResetButton?: boolean;
}

const GenericFilterBox = (props: Props) => {
  const [showExtras, setShowExtras] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const [showResetAndSerchButton, setShowResetAndSerchButton] = useState<boolean>(true);

  const { t } = useTranslation(["operation"]);

  const [elementsShown, elementsHidden] = useMemo(() => {
    const array = React.Children.toArray(props.children);

    array.forEach((element, index) => {
      if (isFragment(element)) {
        const el = element as any;
        array.splice(index, 1, ...React.Children.toArray(el.props.children));
      }
    });

    return [array.slice(0, 3), array.slice(3, array.length)];
  }, [props.children]);

  useEffect(() => {
    setIsChange(true);
    if (props.showResetAndSerchButton !== undefined)
      setShowResetAndSerchButton(props.showResetAndSerchButton);
  }, [props.showResetAndSerchButton]);

  const onResetFilters = () => {
  	setShowExtras(false);
    props.onReset && props.onReset();
  };
  
  const onSearch = () => {
    setShowExtras(false);
    props.onSearch && props.onSearch();
  }

  return (
    <Box
      m={2}
      sx={{ flexGrow: 1 }}
      border={"1px solid #DBE4E9"}
      boxShadow={"0px 4px 4px rgba(0, 0, 0, 0.25)"}
      borderRadius={"4px"}
    >
      <Box>
        <Grid container columns={12} p={2} spacing={2.5} alignItems="start">
          {elementsShown.map((element, index) => {
            return (
              <Grid
                key={`generic-filter-box-elements-shown-${index}`}
                item
                xl={3}
                lg={3}
                md={6}
                xs={12}
              >
                {element}
              </Grid>
            );
          })}
          <Grid
            item
            lg={3}
            md={6}
            xs={12}
            display="flex"
            alignItems="center"
			alignSelf="center"
            ml="auto"
          >
            <Grid
              container
              justifyContent={"flex-end"}
              spacing="16px"
              wrap="nowrap"
              flexWrap={"nowrap"}
            >
              {showResetAndSerchButton && isChange && (
                <Grid item xs={5} display="flex" justifyContent="end">
                  <Button
                    size="icon"
                    variant="text"
                    color="accent"
                    disabled={props.disableResetButton}
                    onClick={onResetFilters}
					startIcon={<Replay />}
                  >
                    {t("tooltipTitle.clearFilters")}
                  </Button>

                </Grid>
              )}

              {elementsHidden.length > 0 && (
                <Grid item xs={5} display="flex" justifyContent="end">
                  <Button
                    size="icon"
                    variant="text"
                    onClick={() => setShowExtras(!showExtras)}
                    style={{
                      color: showExtras ? "black" : "#d12c93",
                    }}
					startIcon={<FilterAltIcon />}
                  >
                    {showExtras
                      ? t("tooltipTitle.close")
                      : t("genericFilterBox.btnFilter")}
                  </Button>

                </Grid>
              )}

              {showResetAndSerchButton && isChange && (
                <Grid item xs={2} display="flex" justifyContent="end">
                  <Button
                    size="icon"
                    variant="contained"
                    style={{
                      color: "white",
                      backgroundColor: "#d12c93",
                    }}
                    onClick={onSearch}
                    {...(props.formId
                      ? { type: "submit", form: props.formId }
                      : {})}
                  >
                    <Tooltip title={t("tooltipTitle.search")}>
                      <Search />
                    </Tooltip>
                  </Button>

                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {showExtras && (
        <Box>
          <Grid container columns={12} p={2} spacing={2.5} alignItems="center">
            {elementsHidden.map((element, index) => {
              return (
                <Grid
                  key={`generic-filter-box-elements-hidden-${index}`}
                  item
                  lg={3}
                  md={6}
                  xs={12}
                >
                  {element}
                </Grid>
              );
            })}
          </Grid>
        </Box>
      )}
    </Box>
  );
};

export default GenericFilterBox;
